import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Products } from '@app/_models';
import { environment } from '@environments/environment';


@Injectable({
    providedIn: 'root'
})
export class AdvancedSearchService {

    constructor(private http: HttpClient) { }


    getSearchInfo(params){
        return this.http.post<any>(`${environment.apiUrl}/homepage/search-info`,params);
    }

    
    getQuickSearchResult(query, type): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/homepage/quick-search`, { params: { query, type } });
    }

}


